import { Injectable } from '@angular/core';
@Injectable()
export class Pinger {

    runPing(a, b) {
        var opt = a || {}, favicon = opt.favicon || "/favicon.ico", timeout = opt.timeout || 0;
        function c(a) {
            d && clearTimeout(d);
            var c = Date.now() - e;
            return "function" == typeof b ? "error" === a.type ? (console.error("error loading resource"), b("error", c)) : b(null, c) : void 0
        }
        var img = new Image;
        var d, e = Date.now();
        img.onload = c, img.onerror = c, timeout && (d = setTimeout(c, timeout)), img.src = a + favicon + "?" + +new Date
    }

}



// WEBPACK FOOTER //
// ./src/providers/pinger/pinger.ts